window.nobid_environment = 'prod'
window.nobid_endpoint = 'https://reports.nobid.io/console'; 
	
if (process.env['NODE_ENV']==='development') {
	window.nobid_environment = 'dev';
	window.nobid_endpoint = 'http://localhost:3000/console';
}
